module.exports = __webpack_public_path__ + "static/media/pla_saf_wor_loa.fefd0437.png";